import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21479bcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Кол-во карманов", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Карманы (%)", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Совокупность (%)", -1))
const _hoisted_4 = { class: "consolidated-report__graphics" }
const _hoisted_5 = { class: "consolidated-report__checkboxes" }
const _hoisted_6 = { class: "consolidated-report__checkbox" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "consolidated-report__checkbox" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "consolidated-report__title" }, "Повторный приём", -1))
const _hoisted_11 = { class: "consolidated-report__recleaning" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Подтвердить ")

import { computed, onMounted, PropType, ref, watch } from 'vue'
import {
  ConsolidatedDataType,
  ConsolidatedTableType,
  GraphicType,
} from '@/shared/types'
import { useRoute } from 'vue-router'
import { periodontalReportApi } from '@/shared/api'
import { declination, showErrorMessage } from '@/shared/utils'
import { ElMessage } from 'element-plus'
import {
  useOrganizationModules,
  usePeriodontalReport,
} from '@/shared/composables'
import { CHECKED_ICON_SVG } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  isPdfMode: Boolean,
  plaque: Number,
  bleeding: Number,
  reCleaning: Number,
  suppuration: Number,
  pockets: Number,
  pocketsTable: Array as PropType<ConsolidatedTableType[]>,
  consolidatedData: Object as PropType<ConsolidatedDataType>,
},
  setup(__props) {

const props = __props



const { setUpdateReport } = usePeriodontalReport()

const { organizationModules } = useOrganizationModules()

const route = useRoute()

const currentHighRowIndex = ref(6)

const consolidatedData = ref<ConsolidatedDataType>({
  diabetes: false,
  smoking: false,
})

const legends = [
  'Через 3 месяца',
  'Через 4 месяца',
  'Через 6 месяцев',
  'Через 9 месяцев',
  'Через 12 месяцев',
]

const signature = computed(() =>
  declination(props.reCleaning, ['месяц', 'месяца', 'месяцев'])
)

const observationTableData: ConsolidatedTableType[] = [
  {
    four: 30,
    five: 20,
    moreSix: 4,
  },
  {
    four: 20,
    five: 10,
    moreSix: 3,
  },
  {
    four: 20,
    five: 6,
    moreSix: 2,
  },
  {
    four: 10,
    five: 4,
    moreSix: 1,
  },
  {
    four: 10,
    five: 2,
    moreSix: 1,
  },
]

const reportId = computed((): string | string[] => route.params.reportId)
const isPreviewMode = computed(() => route.query['view-mode'] === '1')

const graphics = computed((): GraphicType[] => [
  {
    value: props.plaque,
    title: 'Налёт',
  },
  {
    value: props.pockets,
    title: 'Карманы ≥ 4мм',
  },
  {
    value: props.bleeding,
    title: 'Кровоточивость',
  },
])

watch(props.consolidatedData, () => {
  currentHighRowIndex.value = 6
  consolidatedData.value.smoking = props.consolidatedData.smoking
  consolidatedData.value.diabetes = props.consolidatedData.diabetes
})

watch(
  () => props.pockets,
  () => {
    currentHighRowIndex.value = 6
  }
)

const pocketsTableRowClasses = ({ rowIndex }: { rowIndex: number }) => {
  if (rowIndex === 2) {
    return 'success-row'
  }

  return 'default-row'
}

const observationTableCellClasses = ({ rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    return getTableCellClassName(
      props.pocketsTable[2].four,
      observationTableData[rowIndex].four,
      observationTableData[rowIndex + 1]?.four,
      rowIndex
    )
  }

  if (columnIndex === 1) {
    return getTableCellClassName(
      props.pocketsTable[2].five,
      observationTableData[rowIndex].five,
      observationTableData[rowIndex + 1]?.five,
      rowIndex
    )
  }

  if (columnIndex === 2) {
    return getTableCellClassName(
      props.pocketsTable[2].moreSix,
      observationTableData[rowIndex].moreSix,
      observationTableData[rowIndex + 1]?.moreSix,
      rowIndex
    )
  }
}

const getTableCellClassName = (
  currentValue: number,
  valueFromTable: number,
  nextValueFromTable: number,
  rowIndex: number
): string => {
  if (
    (rowIndex === 0 && currentValue > valueFromTable) ||
    (rowIndex === 4 && currentValue <= valueFromTable) ||
    (currentValue <= valueFromTable && currentValue > nextValueFromTable)
  ) {
    if (rowIndex < currentHighRowIndex.value) {
      currentHighRowIndex.value = rowIndex
    }

    return 'success-cell'
  }

  return 'default-cell'
}

const handleChangeSmoking = () => {
  consolidatedData.value.smoking = !consolidatedData.value.smoking
}

const handleChangeDiabetes = () => {
  consolidatedData.value.diabetes = !consolidatedData.value.diabetes
}

const handleSaveAnalyze = async (): Promise<void> => {
  const [error] = await periodontalReportApi.saveConsolidatedAnalyze(
    Number(reportId.value),
    consolidatedData.value
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Сводный анализ сохранен',
      type: 'success',
    })

    setUpdateReport(true)
  }
}

onMounted((): void => {
  consolidatedData.value.diabetes = props.consolidatedData?.diabetes
  consolidatedData.value.smoking = props.consolidatedData?.smoking
})

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'consolidated-report--preview': _unref(isPreviewMode) || __props.isPdfMode }, "consolidated-report"])
  }, [
    (_unref(isPreviewMode) || __props.isPdfMode)
      ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_row, {
      class: _normalizeClass([{
        'consolidated-report__content--preview': _unref(isPreviewMode) || __props.isPdfMode,
      }, "consolidated-report__content"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass([{
            'consolidated-report__title--preview': _unref(isPreviewMode) || __props.isPdfMode,
          }, "consolidated-report__title"])
            }, " Сводный анализ ", 2),
            _createVNode(_component_el_row, { class: "consolidated-report__row" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      data: __props.pocketsTable,
                      "row-class-name": pocketsTableRowClasses,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          width: _unref(isPreviewMode) || __props.isPdfMode ? 51 : 60,
                          label: "4мм",
                          prop: "four"
                        }, null, 8, ["width"]),
                        _createVNode(_component_el_table_column, {
                          width: _unref(isPreviewMode) || __props.isPdfMode ? 51 : 60,
                          label: "5мм",
                          prop: "five"
                        }, null, 8, ["width"]),
                        _createVNode(_component_el_table_column, {
                          width: _unref(isPreviewMode) || __props.isPdfMode ? 51 : 60,
                          label: "≥6мм",
                          prop: "moreSix"
                        }, null, 8, ["width"])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 13,
                  class: "consolidated-report__legends"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    (__props.pocketsTable?.length)
                      ? (_openBlock(), _createBlock(_component_el_table, {
                          key: 0,
                          "cell-class-name": observationTableCellClasses,
                          data: observationTableData,
                          border: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              width: _unref(isPreviewMode) || __props.isPdfMode ? 51 : 60,
                              label: "4мм",
                              prop: "four"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode("≤" + _toDisplayString(row.four) + "%", 1)
                              ]),
                              _: 1
                            }, 8, ["width"]),
                            _createVNode(_component_el_table_column, {
                              width: _unref(isPreviewMode) || __props.isPdfMode ? 51 : 60,
                              label: "5мм",
                              prop: "five"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode("≤" + _toDisplayString(row.five) + "%", 1)
                              ]),
                              _: 1
                            }, 8, ["width"]),
                            _createVNode(_component_el_table_column, {
                              width: _unref(isPreviewMode) || __props.isPdfMode ? 51 : 60,
                              label: "≥6мм",
                              prop: "moreSix"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode("≤" + _toDisplayString(row.moreSix) + "%", 1)
                              ]),
                              _: 1
                            }, 8, ["width"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 13,
                  class: "consolidated-report__legends"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(legends, (legend) => {
                      return _createElementVNode("p", null, _toDisplayString(legend), 1)
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(isPreviewMode) || __props.isPdfMode)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_divider, {
                  class: "divider",
                  direction: "vertical"
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_col, {
          span: _unref(isPreviewMode) || __props.isPdfMode ? 10 : 12
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass([{
            'consolidated-report__title--preview': _unref(isPreviewMode) || __props.isPdfMode,
          }, "consolidated-report__title"])
            }, " Графики в процентах ", 2),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(graphics), (graphic, index) => {
                return (_openBlock(), _createBlock(_component_el_row, {
                  key: index,
                  class: "consolidated-report__graphic"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 21 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_progress, {
                          percentage: graphic.value,
                          "stroke-width": 27,
                          class: "consolidated-report__progress",
                          "text-inside": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(graphic.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["percentage"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_col, { span: 2 }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(graphic.value) + "%", 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_checkbox, {
                  modelValue: consolidatedData.value.smoking,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((consolidatedData.value.smoking) = $event)),
                  disabled: _unref(isPreviewMode) || __props.isPdfMode,
                  label: "Курение"
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("div", {
                  class: "consolidated-report__checkbox-icon",
                  onClick: handleChangeSmoking,
                  innerHTML: _unref(CHECKED_ICON_SVG)
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_checkbox, {
                  modelValue: consolidatedData.value.diabetes,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((consolidatedData.value.diabetes) = $event)),
                  disabled: _unref(isPreviewMode) || __props.isPdfMode,
                  label: "Диабет"
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("div", {
                  class: "consolidated-report__checkbox-icon",
                  onClick: handleChangeDiabetes,
                  innerHTML: _unref(CHECKED_ICON_SVG)
                }, null, 8, _hoisted_9)
              ])
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, " через " + _toDisplayString(`${__props.reCleaning} ${_unref(signature)}`), 1)
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    }, 8, ["class"]),
    (!_unref(isPreviewMode) && !__props.isPdfMode)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          disabled: _unref(organizationModules).indexOf('periodontology') <= -1,
          class: "consolidated-report__button",
          round: "",
          type: "primary",
          onClick: handleSaveAnalyze
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})